import { CUSTOM_PROCEDURE_OPTION_DISPLAY_SUFFIX } from "@/shared/constants/custom-procedure-option-display";

/**
 * @param baseDisplay Procedure display label without the practice-custom suffix.
 * @returns Value suitable for ValueSetExpansionContains.display when the coding is practice-custom.
 */
export function formatCustomProcedureOptionDisplay(baseDisplay: string): string {
  const trimmed = baseDisplay.trimEnd();
  return `${trimmed} ${CUSTOM_PROCEDURE_OPTION_DISPLAY_SUFFIX}`;
}

/**
 * Inverse of {@link formatCustomProcedureOptionDisplay} for picker display only.
 * @param display ValueSet expansion `display` string.
 */
export function parseCustomProcedureOptionDisplay(display: string): {
  baseDisplay: string;
  hasCustomSuffix: boolean;
} {
  const normalizedDisplay = display.trim();
  if (normalizedDisplay.endsWith(CUSTOM_PROCEDURE_OPTION_DISPLAY_SUFFIX)) {
    const baseDisplay = normalizedDisplay
      .slice(0, -CUSTOM_PROCEDURE_OPTION_DISPLAY_SUFFIX.length)
      .trimEnd();
    return { baseDisplay, hasCustomSuffix: true };
  }
  return { baseDisplay: normalizedDisplay, hasCustomSuffix: false };
}
